import { useState } from 'react';
import { exists } from 'lib/types';
import TabGroup, { TabOption } from 'lib/components/Tabs';
import SettingsPage from 'routes/settings/SettingsPage';
import { selectActiveOrganization } from 'redux/auth';
import { useAppSelector } from 'redux/hooks';
import LoadingState from 'components/LoadingState';
import NoticeRatesTable from './NoticeRatesTable';
import CrossPublisherFees from './crossPublisherFees';

const RATES_TABLE_TAB: TabOption = {
  label: 'Rates',
  enabled: true,
  id: 'rates-table-tab'
};

const CROSS_PUBLISHER_FEES_SETTINGS: TabOption = {
  label: 'Cross-Publisher Fees',
  enabled: true,
  id: 'cross-publisher-fees-settings'
};

const RATES_TABS = [RATES_TABLE_TAB, CROSS_PUBLISHER_FEES_SETTINGS];

export default function RatesSettings() {
  const activeOrganization = useAppSelector(selectActiveOrganization);
  const [rateSettingsTab, setRateSettingsTab] = useState(RATES_TABLE_TAB);

  if (!exists(activeOrganization)) {
    return <LoadingState />;
  }

  return (
    <SettingsPage>
      <TabGroup
        onClickTab={setRateSettingsTab}
        activeTab={rateSettingsTab}
        tabs={RATES_TABS}
        id="rates-settings-tabs"
      />
      {rateSettingsTab.label === RATES_TABLE_TAB.label && (
        <NoticeRatesTable activeOrganization={activeOrganization} />
      )}
      {rateSettingsTab.label === CROSS_PUBLISHER_FEES_SETTINGS.label && (
        <CrossPublisherFees activeOrganization={activeOrganization} />
      )}
    </SettingsPage>
  );
}
